import { useTranslation } from 'react-i18next'

import { daysOfWeek } from '@/constants/days-of-week'

const useDaysOfWeek = () => {
  const { t } = useTranslation('common')

  return daysOfWeek.map(day => ({
    label: t(`days-of-week.short.${day}`),
    value: day,
    labelLong: t(`days-of-week.full.${day}`)
  }))
}

export default useDaysOfWeek
